import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=1fb960fb&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=1fb960fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb960fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb960fb')) {
      api.createRecord('1fb960fb', component.options)
    } else {
      api.reload('1fb960fb', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=1fb960fb&scoped=true&", function () {
      api.rerender('1fb960fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/Statistics.vue"
export default component.exports